import { render } from "./FiltersWrapper.vue?vue&type=template&id=7ec68981&scoped=true"
import script from "./FiltersWrapper.vue?vue&type=script&lang=js"
export * from "./FiltersWrapper.vue?vue&type=script&lang=js"

import "./FiltersWrapper.vue?vue&type=style&index=0&id=7ec68981&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec68981"]])

export default __exports__